// src/auth/screens/TenantPicker.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';

export default function TenantPicker() {
  const { tenants, selectTenant, isSuperadmin, setAdminMode } = useAuth();
  const navigate = useNavigate();

  function handleSuperadminEntry() {
    setAdminMode(true);
    navigate('/admin/users', { replace: true });
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0e0e18', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ width: '100%', maxWidth: '420px', padding: '0 24px' }}>
        <h1 style={{ color: '#e4e4ec', fontSize: '22px', fontWeight: 700, marginBottom: '8px' }}>Seleziona tenant</h1>
        <p style={{ color: '#7a7a8e', fontSize: '14px', marginBottom: '32px' }}>Scegli l'organizzazione con cui vuoi lavorare</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {tenants.map(tenant => (
            <button
              key={tenant.tenant_id}
              onClick={() => selectTenant(tenant.tenant_id)}
              style={{ padding: '14px 18px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.04)', color: '#e4e4ec', cursor: 'pointer', textAlign: 'left', fontSize: '15px', fontWeight: 600 }}
            >
              {tenant.display_name}
              <span style={{ display: 'block', fontSize: '12px', color: '#7a7a8e', fontWeight: 400, marginTop: '2px' }}>{tenant.role}</span>
            </button>
          ))}
        </div>

        {isSuperadmin && (
          <>
            <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', margin: '24px 0' }} />
            <button
              onClick={handleSuperadminEntry}
              style={{ width: '100%', padding: '14px 18px', borderRadius: '10px', border: '1px solid rgba(232,0,45,0.4)', background: 'rgba(232,0,45,0.1)', color: '#E8002D', cursor: 'pointer', textAlign: 'left', fontSize: '15px', fontWeight: 600 }}
            >
              Superadmin Dashboard
              <span style={{ display: 'block', fontSize: '12px', color: '#7a7a8e', fontWeight: 400, marginTop: '2px' }}>Gestione utenti e tenant</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
